import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";

import pdf1 from "../../assets/pdf/empanel_list.pdf";
import pdf2 from "../../assets/pdf/pdf2.pdf";
import pdf3 from "../../assets/pdf/pdf3.pdf";

const documentsData = [
  {
    id: 2,
    title: "Powerloom Modernization Scheme G.O. Document",
    file: pdf2,
  },
  {
    id: 3,
    title: "Amended Technology Upgradation Fund Scheme(A-TUFS) Circular",
    file: pdf3,
  },
  {
    id: 1,
    title: "List of Empaneled Suppliers",
    file: pdf1,
  },
];
 
const handleDownload = (fileUrl, fileName) => {
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = fileName;
  link.click();
};

const ReferenceDocuments = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Reference Documents</CardTitle>
      </CardHeader>

      <CardContent className="pt-6">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-primary">Sl No.</TableHead>
              <TableHead className="text-primary">Title</TableHead>
              <TableHead className="text-primary">Action</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {documentsData.map((doc, index) => (
              <TableRow key={doc.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{doc.title}</TableCell>

                <TableCell>
                  <Button
                    type="button"
                    onClick={() =>
                      handleDownload(doc.file, `document_${doc.id}.pdf`)
                    }
                  >
                    Download
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default ReferenceDocuments;
